import { useCallback, useRef, useState } from "react";
import { Button, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import "../styles/registration.scss";
import { RegistrationStep1, RegistrationStep2, SMSVerificationModal, UserExistsModal } from "../components";
import { registration, setFilters, userExists } from "../components/api";
import { setNotificationMessage, setShowNotification } from "../store";
import Modal from 'react-modal';

const steps = [{
    component: (props) => <RegistrationStep1 {...props} />,
    apiFunction: (data) => registration(data)
},
{
    component: (props) => <RegistrationStep2 {...props} />,
    apiFunction: (data) => setFilters(data)
}];

export const Registration = () => {
    const formDataRef = useRef(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [isFormValid, setIsFormValid] = useState(false);
    const [resposeData, setResponseData] = useState(null);
    const [smsVerificationModalOpen, setSmsVerificationModalOpen] = useState(false);
    const [phone, setPhone] = useState(null);
    const [numberConfirmed, setNumberConfirmed] = useState(false);
    const [userExistsModalOpen, setUserExistsModalOpen] = useState(false);

    Modal.setAppElement('#root');

    const handleSetIsFormValid = useCallback((valid) => {
        setIsFormValid(valid);
    }, []);

    const login = () => {
        window.location.href = "/authorization";
    }

    const handleConfirmModal = () => {
        const data = formDataRef.current.getData();

        steps[currentStep].apiFunction(data)
            .then(res => {
                setResponseData(res);
                setCurrentStep(currentStep + 1);
                setIsFormValid(false);
                setSmsVerificationModalOpen(false);
                setNumberConfirmed(true);
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.errors;
                setNotificationMessage(errorMessageData
                    ? Object.values(errorMessageData).join(", ")
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }
    const handleConfirm = () => {
        const data = formDataRef.current.getData();

        steps[currentStep].apiFunction(data)
            .then(res => {
                setResponseData(res);
                document.location.href = "/registrationFinal";
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.errors;
                setNotificationMessage(errorMessageData
                    ? Object.values(errorMessageData).join(", ")
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    };

    const continueButtonClick = () => {
        if(!numberConfirmed){
            if (formDataRef.current) {
                const data = formDataRef.current.getData();
                setPhone(data.phone);
                userExists({phoneNumber: data.phone}) 
                    .then(() => {setUserExistsModalOpen(true)})
                    .catch((error) => {
                        if (error?.response && error.response?.status === 404)
                        {
                            setSmsVerificationModalOpen(true);
                        }
                        else
                        {
                            const errorMessageData = error?.response?.data?.message;
                            setNotificationMessage(errorMessageData
                                ? errorMessageData
                                : "Произошла непредвиденная ошибка");
                            setShowNotification(true);
                        }
                    });
            }
        }
        else{
            handleConfirm();
        }
    };

    const CurrentStepComponent = steps[currentStep].component;

    return (
        <div className="registration">
            <div className="registration__head">
                <div className="registration__info">
                    <h2>Регистрация</h2>
                    <p style={{ color: "#646464ff" }}>Шаг {currentStep + 1}/{steps.length}</p>
                </div>

                <IconButton onClick={() => login()}>
                    <CloseIcon />
                </IconButton>
            </div>
            <CurrentStepComponent
                setIsFormValid={handleSetIsFormValid}
                ref={formDataRef}
                additionalData={resposeData}
            />
            <Button variant="contained" disabled={!isFormValid} onClick={() => continueButtonClick()}>Продолжить</Button>
        <SMSVerificationModal 
            isOpen={smsVerificationModalOpen}
            phone={phone}
            onClose={() => setSmsVerificationModalOpen(false)}
            onConfirm={handleConfirmModal}
        />
        <UserExistsModal 
            isOpen={userExistsModalOpen}
            phone={phone}
            onClose={() => setUserExistsModalOpen(false)}
        />
        </div>
    );
}